const binding = { modules: {}, dataActions: {} };

    (binding.modules['eve-form-select'] = {
        c: () => require('partner/modules/eve-form-select/eve-form-select.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-form-select',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-form-select'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eve-form-select|eve-form-select'] = {
                c: () => require('partner/modules/eve-form-select/eve-form-select.view.tsx'),
                cn: '__local__-__local__-eve-form-select'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };